'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdAirlineSeatIndividualSuite = function MdAirlineSeatIndividualSuite(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm31.6 11.6q2.8 0 4.8 2t2 4.8v10h-36.8v-16.8h3.4v11.8h13.4v-11.8h13.2z m-20 10q-2 0-3.5-1.4t-1.5-3.6 1.5-3.5 3.5-1.5 3.6 1.5 1.4 3.5-1.4 3.6-3.6 1.4z' })
        )
    );
};

exports.default = MdAirlineSeatIndividualSuite;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/airline-seat-individual-suite.js
// module id = 2588
// module chunks = 0